<div class="input-group">
    <input 
        type="text" 
        class="form-control filter-by-search-by" 
        placeholder="Search" 
        [ngModel]="searchText" 
        (ngModelChange)="onChange($event)"
        (blur)="onBlurEvent()"
        (click)="onTouchedCallback()"
        [disabled]="isDisabled"/>
    <span class="input-group-append">
        <button type="button" 
            class="input-group-text btn btn-secondary search-button"
            [ladda]="isBusy"
            [disabled]="isDisabled"
            (click)="onSearchButtonClicked()">
            <i class="fas fa-search"></i>
        </button>
    </span>
    <paetep-reset-button *ngIf="onReset.observed"
        class="ml-2" 
        (onClick)="onResetButtonClicked()" 
        [isBusy]="isBusy"
        [isDisabled]="isDisabled"></paetep-reset-button>
</div>
